module.exports = __webpack_public_path__ + "static/img/114.115.247.24.57369385.png";